// extracted by mini-css-extract-plugin
export default {"list":"eu0TQ5ZxkNIVhtH3yVks"};